import type {HTMLAttributes} from 'react'
import styled, {css} from 'styled-components'

import {Box, ListIcon, Text, tokens} from '@pleo-io/telescope'
import {Check, Close} from '@pleo-io/telescope-icons'

import {benefitsCategories} from './helpers'
import {ListItemLight} from './modal-choose-plans.styles'

export interface PlanBenefit {
    text: string
    inactive?: boolean
}

const sharedStyles = css`
    font-size: ${tokens.fontSmall};
    margin-right: ${tokens.spacing6};
`

const BenefitsCategoryWrapper = styled.div`
    margin-bottom: ${tokens.spacing16};
`

type Props = {
    benefits: Array<PlanBenefit>
    title: string
} & HTMLAttributes<HTMLUListElement>

const PlanBenefitDescription = styled(Text).attrs<
    Props & Partial<PlanBenefit>,
    Partial<PlanBenefit>
>(({inactive}) => ({
    inactive,
}))`
    text-decoration: ${(props) => (props.inactive ? 'line-through' : '')};
    ${sharedStyles}
`

const PlanBenefitsList = ({benefits, title}: Props) => {
    return (
        <>
            {title !== benefitsCategories.legacy && (
                <Box>
                    <Text color="shade800" space={4} variant={'small-subtle'} uppercase>
                        {title}
                    </Text>
                </Box>
            )}

            <BenefitsCategoryWrapper>
                {benefits &&
                    benefits.map(({text, inactive}, index) => {
                        const icon = inactive ? Close : Check
                        const iconColor = inactive ? tokens.shade500 : tokens.pink700
                        const color = inactive ? 'shade600' : 'shade800'
                        return (
                            <Box key={index}>
                                <ListItemLight key={text}>
                                    {text && <ListIcon as={icon} color={iconColor} size={20} />}
                                    <PlanBenefitDescription
                                        variant="small-subtle"
                                        color={color}
                                        inactive={inactive}
                                    >
                                        {text}
                                    </PlanBenefitDescription>
                                </ListItemLight>
                            </Box>
                        )
                    })}
            </BenefitsCategoryWrapper>
        </>
    )
}

export default PlanBenefitsList
